import { render, staticRenderFns } from "./orgTreePanel.vue?vue&type=template&id=bf91c55a&scoped=true"
import script from "./orgTreePanel.vue?vue&type=script&lang=js"
export * from "./orgTreePanel.vue?vue&type=script&lang=js"
import style0 from "./orgTreePanel.vue?vue&type=style&index=0&id=bf91c55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf91c55a",
  null
  
)

export default component.exports